var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fz-12"},[_vm._v("\n        "+_vm._s(_vm.row[_vm.column.propType])+"\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }